module.exports = __webpack_public_path__ + "static/media/sanded-oak-brown.27f7a8ae.jpg";